










































































import Vue from 'vue';
import { Auth, LocalStorage } from '../../generated';
import { AuthenticationService } from '../../generated/services/AuthenticationService';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Login',
  components: {},
  data() {
    return {
      dialog: false,
      email: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters([
      'loggedInStatusMessage',
    ]),
  },
  methods: {
    ...mapActions([
      'updateLoggedInStatus',
    ]),
    handleOnClickLogout(): void {
      AuthenticationService.postAuthenticationServiceRcmsApi1AuthLogout({});
      LocalStorage.setAccessToken('');
      LocalStorage.setRefreshToken('');
      this.updateLoggedInStatus({loggedIn: false});
    },
    handleOnClickLogin(): void {
      if (this.email === '' && this.password === '') {
        Auth.createToken({
          requestBody: {}
        }).then(() => {
          this.updateLoggedInStatus({loggedIn: true, anonymous: true});
        });
      } else {
        Auth.login({
          requestBody: { email: this.email, password: this.password },
        }).then(() => {
          this.updateLoggedInStatus({loggedIn: true});
        });
      }
    },
    handleOnClickSamlLogin(e: Event) {
      e.stopPropagation();
      e.preventDefault();

      function createNodeWithAttributes(
        tagName: string,
        attributes: { nm: string; val: string }[] = []
      ) {
        const node = document.createElement(tagName);
        attributes.forEach(({ nm, val }) => node.setAttribute(nm, val));
        return node;
      }
      const form = createNodeWithAttributes('form', [
        { nm: 'id', val: 'google_login_saml' },
        { nm: 'action', val: '/direct/login/saml_login/?spid=1' },
        { nm: 'method', val: 'POST' },
      ]);
      const input = createNodeWithAttributes('input', [
        { nm: 'type', val: 'hidden' },
        { nm: 'name', val: 'api_id' },
        { nm: 'value', val: '1' },
      ]);
      form.appendChild(input);

      (document.querySelector('body') as HTMLBodyElement).appendChild(form);
      (document.querySelector(
        '#google_login_saml'
      ) as HTMLFormElement).submit();
    },
  },
});
